import Container from './AdoptOnSide.container';
import AdoptOnSide from './AdoptOnSide';
export default Container(AdoptOnSide);
